import React from 'react';
import { Colorways } from '@uds/colorway';
import { ShortcodeProps } from 'presentation/components/Shortcode';

import Header from './QuestionHeader';
import Body from './QuestionBody';
import { getClassNames } from './Question.stylesheet';

interface OuterProps {
  selected: number | null;
  id: number;
  hBaseline: number;
  colorway: Colorways;
  question: ShortcodeProps;
  answer: ShortcodeProps;
  duration: number;
  onChange: (evt: any) => void;
}

export const PureQuestion = ({
  id,
  colorway,
  hBaseline,
  selected,
  question,
  answer,
  duration,
  onChange,
}: OuterProps) => {
  const isFirst = id === 0;
  const active = selected === id;
  const classNames = getClassNames({ colorway, isFirst, isActive: active });
  const onClick = () => (active ? onChange(null) : onChange(id));

  return (
    <div className={classNames.root}>
      <Header
        colorway={colorway}
        hBaseline={hBaseline}
        active={active}
        question={question}
        onClick={onClick}
        isFirst={isFirst}
        duration={duration}
      />
      <Body duration={duration} colorway={colorway} active={active} answer={answer} />
    </div>
  );
};

PureQuestion.displayName = 'Question';

export default PureQuestion;
